import React, { useState } from 'react';
import api from '../services/api';
import toast from 'react-hot-toast';
import { FiUpload, FiX } from 'react-icons/fi';
import '../styles/PlateRecognition.css';

const PlateRecognition = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!['image/png', 'image/jpeg', 'image/jpg'].includes(file.type)) {
        toast.error('Apenas PNG, JPG e JPEG são suportados');
        return;
      }

      if (file.size > 10 * 1024 * 1024) {
        toast.error('Arquivo muito grande (máx 10MB)');
        return;
      }

      setSelectedFile(file);
      const reader = new FileReader();
      reader.onload = (e) => setPreview(e.target.result);
      reader.readAsDataURL(file);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.currentTarget.classList.add('drag-over');
  };

  const handleDragLeave = (e) => {
    e.currentTarget.classList.remove('drag-over');
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.currentTarget.classList.remove('drag-over');
    const file = e.dataTransfer.files[0];
    if (file) {
      const input = document.createElement('input');
      input.type = 'file';
      Object.defineProperty(input, 'files', { value: e.dataTransfer.files });
      handleFileSelect({ target: input });
    }
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      toast.error('Selecione uma imagem');
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append('image', selectedFile);

    try {
      const response = await api.post('/api/plates/recognize', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      setResult(response.data);
      toast.success('Placa reconhecida com sucesso!');
    } catch (error) {
      toast.error(error.response?.data?.error || 'Erro ao reconhecer placa');
    } finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    setSelectedFile(null);
    setPreview(null);
    setResult(null);
  };

  return (
    <div className="plate-recognition-page">
      <h1>Reconhecimento de Placas</h1>

      <div className="recognition-container">
        <div className="upload-section">
          <div
            className="upload-area"
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
          >
            {preview ? (
              <div className="preview-container">
                <img src={preview} alt="Preview" />
                <button className="clear-btn" onClick={handleClear}>
                  <FiX />
                </button>
              </div>
            ) : (
              <div className="upload-placeholder">
                <FiUpload size={48} />
                <p>Clique ou arraste uma imagem aqui</p>
                <small>PNG, JPG, JPEG (máx 10MB)</small>
              </div>
            )}
            <input
              type="file"
              accept="image/png,image/jpeg,image/jpg"
              onChange={handleFileSelect}
              style={{ display: 'none' }}
              id="file-input"
            />
          </div>

          <label htmlFor="file-input" className="file-input-label">
            Selecionar Imagem
          </label>

          <button
            className="btn btn-primary btn-large"
            onClick={handleUpload}
            disabled={!selectedFile || loading}
          >
            {loading ? 'Processando...' : 'Reconhecer Placa'}
          </button>
        </div>

        {result && (
          <div className="result-section">
            <h2>Resultado do Reconhecimento</h2>
            <div className="result-card">
              <div className="result-item">
                <label>Placa Detectada:</label>
                <p className="result-value">{result.plate}</p>
              </div>

              <div className="result-item">
                <label>Formato:</label>
                <p className="result-value">{result.plateFormat}</p>
              </div>

              <div className="result-item">
                <label>Confiança:</label>
                <p className="result-value">{(result.confidence * 100).toFixed(2)}%</p>
              </div>

              <div className="result-item">
                <label>Tempo de Processamento:</label>
                <p className="result-value">{result.processingTime}ms</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PlateRecognition;
